/**
 * Do not edit directly
 */

export default "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48cmVjdCB4PSIyLjI1IiB5PSIyLjI1IiB3aWR0aD0iOS41IiBoZWlnaHQ9IjkuNSIgc3R5bGU9ImZpbGw6bm9uZTsgc3Ryb2tlOiMwMDA7Ii8+PC9zdmc+";